import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

export function FactsheetDocItem({ href }: { href: string }) {
  const handleClick = () =>
    logAnalytics.trackEvent('Primary market essential', 'Request for documentation', 'factsheet');
  return (
    <li className="flex-x justify-content-between list-group-item py-1 px-0 border-top">
      <div className="flex-x gap-2">
        <i className="icon icon-outlined text-secondary">description</i>
        <h6 className="fs-5 fw-medium">
          <FormattedMessage id="documentation.productFactsheet" defaultMessage="Product factsheet" />
        </h6>
      </div>

      <Button onClick={handleClick} variant="flat-primary" className="px-1" as="a" href={href} target="_blank">
        <i className="icon fs-3">save_alt</i>
      </Button>
    </li>
  );
}
